import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accounts-manager-dashboard',
  templateUrl: './accounts-manager-dashboard.component.html',
  styleUrls: ['./accounts-manager-dashboard.component.scss']
})
export class AccountsManagerDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
